import Swiper from "swiper";
import { Navigation } from "swiper/modules";
//import "swiper/swiper-bundle.css";

window.addEventListener("load", () => {
  const testimonialsSlider = [...document.querySelectorAll('.section-testimonials')];

  testimonialsSlider && testimonialsSlider.forEach(slider => {
    if(!slider) return;

    const sliderInit = slider.querySelector('.swiper');

    const nextEl = slider.querySelector('.swiper-button-next');
    const prevEl = slider.querySelector('.swiper-button-prev');

    nextEl ? nextEl.innerHTML = '<svg width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M11.5023 4.32812L17 9.57813L11.4028 9.56422C13.4055 9.56927 14.3959 7.13374 12.9581 5.73963L11.5023 4.32812Z" fill="#012027"/><path d="M17 9.57813L13.3349 13.0781L11.5023 14.8281L12.9549 13.4309C14.411 12.0303 13.4231 9.56928 11.4028 9.56422L17 9.57813Z" fill="#012027"/><path d="M0.999999 9.57813L11.4028 9.56422M17 9.57813L13.3349 13.0781L11.5023 14.8281M17 9.57813L11.5023 4.32812M17 9.57813L11.4028 9.56422M9.66975 16.5781L11.5023 14.8281M9.66974 2.57813L11.5023 4.32812M11.5023 14.8281L12.9549 13.4309C14.411 12.0303 13.4231 9.56928 11.4028 9.56422V9.56422M11.5023 4.32812L12.9581 5.73963C14.3959 7.13374 13.4055 9.56927 11.4028 9.56422V9.56422" stroke="#012027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '';
    prevEl ? prevEl.innerHTML = '<svg width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M6.49769 14.6719L0.999999 9.42187L6.59723 9.43578C4.5945 9.43073 3.60406 11.8663 5.0419 13.2604L6.49769 14.6719Z" fill="#012027"/><path d="M0.999999 9.42187L4.66513 5.92187L6.49769 4.17187L5.04506 5.56914C3.58897 6.96973 4.57687 9.43072 6.59723 9.43578L0.999999 9.42187Z" fill="#012027"/><path d="M17 9.42187L6.59723 9.43578M0.999998 9.42187L4.66513 5.92187L6.49769 4.17187M0.999998 9.42187L6.49769 14.6719M0.999998 9.42187L6.59723 9.43578M8.33025 2.42187L6.49769 4.17187M8.33025 16.4219L6.49769 14.6719M6.49769 4.17187L5.04506 5.56914C3.58897 6.96973 4.57687 9.43072 6.59723 9.43578V9.43578M6.49769 14.6719L5.0419 13.2604C3.60406 11.8663 4.5945 9.43073 6.59723 9.43578V9.43578" stroke="#012027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '';

    const mainSettings = {
      modules: [Navigation],
      loop: true,
      speed: 500,
      initialSlide: 1,
      centeredSlides: true,
      spaceBetween: 0,
      slidesPerView: 1,
      loopPreventsSliding: 3,
      loopAdditionalSlides: 3,
    }

    const navigation = { nextEl: nextEl, prevEl: prevEl };
    const breakpoints = { 768: { slidesPerView: 'auto' }};

    sliderInit && new Swiper(sliderInit, {
      ...mainSettings,
      navigation: navigation,
      breakpoints: breakpoints,
    });
  });
});
